import i18n from 'modules/core/lib/i18n'

import { Banner } from 'modules/layout/components/ResponsivePage/_Body'

export const anonymousForTargetBanner: () => Banner = () => ({
  message: i18n.t('performance_process.reviews.evaluations.anonymously_for_target'),
  icon: 'info-circle-line',
  color: 'note',
})
